import React from 'react';
import classes from 'src/components/CategoryListingPage/ProductList.scss';
import classnames from 'classnames';
import { fromAggregationsQuery, TagsAggregation } from 'src/components/CategoryListingPage/utils/cleanAggregations';
import { useQuery } from '@apollo/client';
import { aggregations, aggregationsVariables } from 'src/queries/__generated__/aggregations';
import categoryQuery from 'src/queries/aggregations.graphql';
import { useDeps } from 'src/hooks/useDeps';
import { Spinner } from 'src/components/Layout/Spinner';
import { filterBestsellerTag } from 'src/components/CategoryListingPage/ProductListItem';
import { ProductItemBySku } from 'src/types/global-types';

type UpsellTagProps = {
    id: string;
    product: ProductItemBySku;
    className?: string;
};

type RenderTagProps = {
    tag: string;
    tagsAggregation: TagsAggregation[];
    onChange?: (checked: boolean, code: string, label: string) => void;
    tagsSelected?: (string | false | null)[];
};

const TAGS_COLORS = {
    'BEST SELLER': '#DC0032',
    '24 HOUR DISPATCH': '#39579a',
    'NEW IN': '#259230',
    ORGANIC: '#FF6C00',
    'NEXT DAY DELIVERY': '#9946c9',
    RECOMMENDED: '#704C40',
    'SELLING FAST': '#DC0032',
    'PRINT AVAILABLE': '#006ADC',
    'EMBROIDERY AVAILABLE': '#80DC00',
    'TOP SELLER': '#9946C9',
    CLEARANCE: '#28BE2E',
};

export const RenderUpsellTags: React.FC<UpsellTagProps> = ({ id, product, className }) => {
    const { data } = useQuery<aggregations, aggregationsVariables>(categoryQuery, {
        variables: {
            idAsString: id,
        },
        ssr: useDeps().env.SSR_GQL,
    });

    if (!data) {
        return <Spinner />;
    }

    const output = fromAggregationsQuery(data.aggregations.aggregations);

    const tagsAggregation =
        output
            ?.find((el) => el.attribute_code === 'product_tags')
            ?.options?.map((o) => {
                return {
                    label: o?.label || '',
                    value: o?.value || '',
                };
            }) || [];

    const productTags = product.productTags ? product.productTags.split(',') : [''];

    const filteredTags = filterBestsellerTag(productTags, tagsAggregation, false);

    return (
        <div className={className}>
            {filteredTags?.map((tag) => (
                <RenderTag key={tag} tag={tag} tagsAggregation={tagsAggregation} />
            ))}
        </div>
    );
};

export const RenderTag: React.FC<RenderTagProps> = ({ tag, tagsAggregation, onChange, tagsSelected }) => {
    const currentTag = tagsAggregation.filter((el) => el.value === tag)[0];

    if (!currentTag) {
        return null;
    }

    const color = TAGS_COLORS[currentTag.label.toUpperCase()];

    const setTag = (label: string) => onChange?.(!tagsSelected?.some((el) => el === label), 'product_tags', label);

    return (
        <span
            onClick={() => setTag(currentTag.label)}
            style={{ background: color || '#000000' }}
            className={classnames(classes.tag, classes.tagPointer)}
        >
            {currentTag.label.toUpperCase()}
        </span>
    );
};

export const AlgoliaTag = ({ tag }) => (
    <span style={{ background: TAGS_COLORS[tag.toUpperCase()] || '#000000' }} className={classes.tag}>
        {tag.toUpperCase()}
    </span>
);
